<div class="search-bar">
  <div class="search-center browse-wrapper flex-row" [formGroup]="searchForm">
    <mat-select formControlName="searchTarget">
      <mat-option value="KEYWORD">Keyword</mat-option>
      <mat-option value="TITLE">Title</mat-option>
      <mat-option value="AUTHOR">Author</mat-option>
      <mat-option value="ISBN">ISBN</mat-option>
      <mat-option value="SERIES">Series</mat-option>
    </mat-select>
    <input (keydown.enter)="submitForm()" formControlName="searchTerm" placeholder="Search term"/>
    <button (click)="submitForm()">
      <img alt="magnifying glass" src="/assets/magnifying-glass.svg" class="magnifying-glass-icon"/>
    </button>
  </div>
</div>
@if (searchResponse$ | async; as response) {
  <div class="browse-wrapper">
    @if (page$ | async; as page) {
      @if (isMobile) {
        <div class="grid-header">
          <div class="flex-row flex-center-space-between">
            <h1>Results ({{ response.totalResults }})</h1>
            <div class="grid-controls">
              Showing {{ page.page * page.limit + 1 }}-{{
                page.page * page.limit + page.limit
              }}
            </div>
          </div>
          <div class="flex-row flex-center-space-between">
            <a class="mobile-filter-trigger pointer center" (click)="facetDrawer.toggle()" [ngClass]="{ 'filter-active' : hasFilters(response)}">
              <mat-icon>filter_list</mat-icon>
              <span class="filter-label">Filters</span>
            </a>
            <ng-container *ngTemplateOutlet="sortAndViewSelect"/>
          </div>
        </div>
      } @else {
        <div class="grid-header flex-row-wrap">
          <h1>Results ({{ response.totalResults }})</h1>
          <div class="grid-controls">
            Showing {{ page.page * page.limit + 1 }}-{{
              page.page * page.limit + page.limit
            }}
            <ng-container *ngTemplateOutlet="sortAndViewSelect"/>
            <span class="page-length">
              <button [ngClass]="{ selected: page.limit === 25 }" (click)="setPageSize(25)">25</button>
              <button [ngClass]="{ selected: page.limit === 50 }" (click)="setPageSize(50)">50</button>
            </span>
          </div>
        </div>
      }
    }

    <div class="main-body">
      <mat-drawer-container class="facet-drawer-container">
        <mat-drawer #facetDrawer [mode]="facetDrawerMode" [(opened)]="filtersOpened" class="facet-drawer">
          <rn-catalog-facet-collection [facets]="response.facets"/>
        </mat-drawer>
        <div class="facet-drawer-content">
          <div class="items">
            @if (displayMode === 'grid') {
              <div class="items item-grid">
                @for (item of response.resultsPage; track item.id) {
                  <div class="item browse-item">
                    <rn-grid-item [catalogRecord]="item"/>
                  </div>
                }
              </div>
            }
            @if (displayMode === 'list') {
              <div class="items item-list">
                @for (item of response.resultsPage; track item.id) {
                  <rn-list-item [catalogRecord]="item" [topBorder]="$first"/>
                }
              </div>
            }
            @if (response.resultsPage.length === 0) {
              <div class="center">
                <h4>No results matching your search parameters.</h4>
              </div>
            }
            @if (page$ | async; as page) {
              @if (page.page > 2 || response.totalResults === 0) {
                <div class="item-request-banner">
                  <ng-container *ngTemplateOutlet="itemRequestBanner"/>
                </div>
              }
            }
            <hr/>
            @if (page$ | async; as page) {
              <div class="page-control" onselectstart="return false">
                <div class="flex-row flex-center-center">
                  <span class="left-arrow" (click)="setPageNumber(page.page - 1)" [ngClass]="{ disable: page.page === 0 }">
                    <mat-icon>arrow_backward</mat-icon>
                  </span>
                  @for (i of getPageNumbersForControl(page.page, response.totalResults, page.limit); track i) {
                    <span class="wrapper" [ngClass]="{ circle: page.page === (i - 1) }" (click)="setPageNumber(i - 1)">
                      <span class="page-number">{{ i }}</span>
                    </span>
                  }
                  <span class="right-arrow" (click)="setPageNumber(page.page + 1)"
                        [ngClass]="{ disable: page.page >= getPageCount(response.totalResults, page.limit) - 1 }">
                    <mat-icon>arrow_forward</mat-icon>
                  </span>
                </div>
              </div>
            }
          </div>
          @if (showExpandedSearch) {
            <ng-container *ngTemplateOutlet="expandedSearchNoResults"/>
          }
        </div>
      </mat-drawer-container>
    </div>
  </div>
} @else {
  <div class="flex-container spinner">
    <mat-spinner/>
  </div>
}

<ng-template #expandedSearchNoResults>
  <div class="expanded-search-no-results">
    @if (showExpandedSearchWarning) {
      <div class="expanded-search-warning flex-row flex-center-start">
        <em class="expanded-search-no-results-icon ri-information-line"></em>
        <span class="heading">Expanded Search Results</span>
        <span>These results will include items that may not be at your library.</span>
        <img (click)="showExpandedSearchWarning = false" class="pointer expanded-search-no-results-img" alt="close" src="/assets/slicons/close.svg"/>
      </div>
    }
    <div class="empty-list">No search results</div>
    <ng-container *ngTemplateOutlet="itemRequestBanner"/>
  </div>
</ng-template>

<ng-template #sortAndViewSelect>
  <span class="sort-by">
    Sort by:
    <select (change)="sortChanged($event)" [ngModel]="sortSelectValue">
      <option value="">Relevance</option>
      <option value="title-asc">Title, a-z</option>
      <option value="title-desc">Title, z-a</option>
      ]
      <option value="author-asc">Author, a-z</option>
      <option value="author-desc">Author, z-a</option>
      <option value="publicationDate-desc">Publication Date, newest first</option>
      <option value="publicationDate-asc">Publication Date, oldest first</option>
    </select>
  </span>
  <span class="display-mode">
    <!-- eslint-disable @angular-eslint/template/prefer-self-closing-tags -- Don't know whether mysterious <ri> should self-close or not.  -->
    <button [ngClass]="{ selected: displayMode === 'grid' }" (click)="setDisplayMode('grid')">
      <ri class="ri-layout-grid-line mode-icon"></ri>
    </button>
    <button [ngClass]="{ selected: displayMode === 'list' }" (click)="setDisplayMode('list')">
      <ri class="ri-list-check mode-icon"></ri>
    </button>
    <!-- eslint-enable @angular-eslint/template/prefer-self-closing-tags -->
  </span>
</ng-template>

<ng-template #itemRequestBanner>
  <div class="message-item-request flex-col flex-start-center">
    <div class="message-item-request-header">
      <img alt="close" src="/assets/slicons/messages.svg" class="message-item-request-icon"/>
      <div>
        <div class="cant-find">Can't find what you're looking for?</div>
        <div>Send an item request.</div>
      </div>
    </div>
    <div class="flex-row-wrap-col-responsive flex-start-space-between full-width">
      <rn-account-status-warning class="item-request-warning-banner" context="placeHold"/>
      <span [matTooltip]="patronStatusSelectors.itemRequestDisabledReason | select">
        <button mat-raised-button color="primary" class="save-button-group save-button item-request-button"
                [disabled]="!(patronStatusSelectors.canPlaceItemRequest | select)" (click)="openItemRequestModal()">
          Item Request
        </button>
      </span>
    </div>
  </div>
</ng-template>
